module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.copy) ? _c('div', {
    staticClass: "admin-copy"
  }, [_c('navbar'), _vm._v(" "), _c('confirm', {
    ref: "confirmdialog"
  }), _vm._v(" "), _c('h2', [_vm._v("Edit Copy \"" + _vm._s(_vm.copy.Signature) + "\"")]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Edition"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copy.EditionId),
      expression: "copy.EditionId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.copy, "EditionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.editions), function(e) {
    return _c('option', {
      domProps: {
        "value": e.Key
      }
    }, [_vm._v(_vm._s(e.Value))])
  }))]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Location"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copy.LocationId),
      expression: "copy.LocationId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.copy, "LocationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locations), function(l) {
    return _c('option', {
      domProps: {
        "value": l.Key
      }
    }, [_vm._v(_vm._s(l.Value))])
  }))]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Consulted"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.copy.ConsultedId),
      expression: "copy.ConsultedId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.copy, "ConsultedId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.consulted), function(c) {
    return _c('option', {
      domProps: {
        "value": c.Key
      }
    }, [_vm._v(_vm._s(c.Value))])
  }))]), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Signature"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Signature"
    },
    model: {
      value: (_vm.copy.Signature),
      callback: function($$v) {
        _vm.$set(_vm.copy, "Signature", $$v)
      },
      expression: "copy.Signature"
    }
  })], 1), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Remarks"
    }
  }, [_c('vue-editor', {
    attrs: {
      "id": "Remarks",
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.copy.Remarks),
      callback: function($$v) {
        _vm.$set(_vm.copy, "Remarks", $$v)
      },
      expression: "copy.Remarks"
    }
  })], 1), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Users Traces"
    }
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Users Trace")]), _vm._v(" "), _c('th', [_vm._v("Explanation")]), _vm._v(" "), _c('th', [_vm._v("Pertaining to")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.copy.Userstraces.Items), function(ut) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(ut.UsersTrace))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(ut.ExplanationShort)
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(ut.UsersTraceType))]), _vm._v(" "), _c('td', [_c('b-button', {
      on: {
        "click": function($event) {
          _vm.editUsersTrace(ut)
        }
      }
    }, [_vm._v("Edit")]), _c('b-button', {
      on: {
        "click": function($event) {
          _vm.deleteUsersTrace(ut)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.addUsersTrace()
      }
    }
  }, [_vm._v("Add Users Trace")])], 1), _vm._v(" "), _c('edit-full-width', {
    attrs: {
      "caption": "Links"
    }
  }, [_c('table', {
    staticClass: "table table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Url")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.copy.Links.Items), function(l) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(l.Description))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": l.Url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(l.Url))])]), _vm._v(" "), _c('td', [_c('b-button', {
      on: {
        "click": function($event) {
          _vm.editLink(l)
        }
      }
    }, [_vm._v("Edit")]), _c('b-button', {
      on: {
        "click": function($event) {
          _vm.deleteLink(l)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }))]), _vm._v(" "), _c('b-button', {
    on: {
      "click": function($event) {
        _vm.addLink()
      }
    }
  }, [_vm._v("Add Link")])], 1), _vm._v(" "), _c('popup', {
    ref: "popupUsersTrace",
    attrs: {
      "titel": "Users Trace",
      "data-vv-scope": "ut"
    },
    on: {
      "okclick": function($event) {
        _vm.beforeSaveUsersTrace();
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(popup) {
        return [(popup.data != null) ? _c('form', {
          attrs: {
            "data-vv-scope": "ut"
          }
        }, [_c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.UsersTrace')
          },
          attrs: {
            "caption": "Users Trace",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.UsersTraceId),
            expression: "popup.data.UsersTraceId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "UsersTrace"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "UsersTraceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.userstraces), function(ut) {
          return _c('option', {
            domProps: {
              "value": ut.Key
            }
          }, [_vm._v(_vm._s(ut.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.UsersTraceType')
          },
          attrs: {
            "caption": "Pertaining to",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.UsersTraceTypeId),
            expression: "popup.data.UsersTraceTypeId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "UsersTraceType"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "UsersTraceTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.userstracetypes), function(utt) {
          return _c('option', {
            domProps: {
              "value": utt.Key
            }
          }, [_vm._v(_vm._s(utt.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.Date')
          },
          attrs: {
            "caption": "Date",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.DateId),
            expression: "popup.data.DateId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "Date"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "DateId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.dates), function(d) {
          return _c('option', {
            domProps: {
              "value": d.Key
            }
          }, [_vm._v(_vm._s(d.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          class: {
            'has-danger': _vm.errors.has('ut.Language')
          },
          attrs: {
            "caption": "Language",
            "required": "true"
          }
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (popup.data.LanguageId),
            expression: "popup.data.LanguageId"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "Language"
          },
          on: {
            "change": function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(popup.data, "LanguageId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }
          }
        }, _vm._l((_vm.languages), function(l) {
          return _c('option', {
            domProps: {
              "value": l.Key
            }
          }, [_vm._v(_vm._s(l.Value))])
        }))]), _vm._v(" "), _c('edit-full-width', {
          attrs: {
            "caption": "Explanation"
          }
        }, [_c('vue-editor', {
          attrs: {
            "id": "Explanation",
            "editorToolbar": _vm.customToolbar
          },
          model: {
            value: (popup.data.Explanation),
            callback: function($$v) {
              _vm.$set(popup.data, "Explanation", $$v)
            },
            expression: "popup.data.Explanation"
          }
        })], 1), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "danger",
            "show": _vm.errors.any()
          }
        }, [_vm._v("Errors")]), _vm._v(" "), _c('b-alert', {
          attrs: {
            "variant": "light",
            "show": !_vm.errors.any()
          }
        }, [_vm._v(" ")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "col-md-12 text-right"
  }, [_c('b-alert', {
    attrs: {
      "variant": "success",
      "show": _vm.saved,
      "dismissible": ""
    },
    on: {
      "dismiss-count-down": _vm.countDownChanged,
      "dismissed": function($event) {
        _vm.saved = 0
      }
    }
  }, [_vm._v("Copy Saved")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.saving
    }
  }, [_vm._v("Saving......")]), _vm._v(" "), (!_vm.saving) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save(false)
      }
    }
  }, [_vm._v("Opslaan, Juffie")]) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save(true)
      }
    }
  }, [_vm._v("Opslaan en sluiten")]) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Annuleren")]) : _vm._e()], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2fc9186","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/admin-copy.vue
// module id = 250
// module chunks = 1